import { Swiper, Text } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useState } from 'react';
import { selectorBlock as block } from '../../utils';
import { useClipSelect } from '../ClipSelectContext';
import ClipSelectDetailCardSlide from './ClipSelectDetailCardSlide';

export interface ClipDetailProps {
  className?: string;
}

const ClipDetail: React.FC<ClipDetailProps> = ({ className }) => {
  const [autoPlay, setAutoPlay] = useState(false);

  const {
    visibleSuggestionIds,
    activeSuggestionId,
    onSuggestionSelect,
  } = useClipSelect();

  return (
    <div className={cn('clip-select-page__detail-bg', className)}>
      <Swiper
        maxSlidesPerView={1}
        preloadNextSlides={1}
        preloadPrevSlides={1}
        initialSlideIndex={
          visibleSuggestionIds.indexOf(activeSuggestionId) || 0
        }
        className={block('detail-container')}
        onSlideChange={newIndex =>
          onSuggestionSelect(visibleSuggestionIds[newIndex])
        }
      >
        {visibleSuggestionIds?.map((id, index) => {
          return (
            <Swiper.Slide
              key={id}
              slideIndex={index}
              className={block('detail-slide')}
            >
              <Text
                variant="p"
                weight={400}
                as="p"
                className={block('detail-instruction')}
              >
                Tap the transcript to edit. Preview quality is reduced for
                playback.
              </Text>

              <ClipSelectDetailCardSlide
                {...{ id, autoPlay }}
                isActive={id === activeSuggestionId}
                onPlaybackChange={setAutoPlay}
              />
            </Swiper.Slide>
          );
        })}
      </Swiper>

      <Swiper.Controls className={block('detail-controls')} />
    </div>
  );
};

export default ClipDetail;
